import type { MasterDetailGridProps } from 'elowen-plugin-ui-kit';

/** The existing single-column workspace grid; selection and detail overlays stay with the caller. */
export function MasterDetailGrid({ children, className = '' }: MasterDetailGridProps) {
  return <div className={`workspace-master-detail ${className}`}>{children}</div>;
}
